var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('h1',[_vm._v("Access denied")]),_c('p',[_vm._v("You do not have permission to perform this function.")])])}
var staticRenderFns = []

export { render, staticRenderFns }